var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"id":"operations_filter"}},[_c('div'),_vm._v(" "),_c('div',{staticClass:"ui segment",style:({
            width: (true) ? '100%' : 'auto',
            margin: 0
        })},[_c('Header',{staticClass:"right floated"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }